<template>
 
<div  class="function_wrap"  :style="!isPhone? 'width:1050px;':'width:95%'  ">
    <!-- border :4.5px solid #af3030; -->
            <consult v-if="!isPhone"></consult>
            <div :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' " :style="'background-color: #fff; min-height:'+(screenHeight-80)+'px;'">
          
                <h1 class="function_wrap_title">律师费计算器</h1>
                <div class="function_wrap_title_EN">LAWYER FEES CALCULATOR</div>
                
                <div class='optionitem' >   
                    <div class="optionitem item_name">案件类型：</div>
                
                  <div  class="optionitem item_detail" >
                        <el-select v-model="index" placeholder="请选择" style="width:100%;" >
                            <el-option
                                v-for="item in kind"
                                :key="item"
                                :value="item">
                            </el-option>
                        </el-select>

                    </div>

                </div>    

                <div class='optionitem' >   
                    <div class="optionitem item_name" >输入金额：</div>
                    <div class="optionitem item_detail"> <el-input type='number' min=0 v-model="inputValue" placeholder="请输入涉案金额"></el-input> </div>
                    
                </div>  

                <div class='optionitem' >   
                        <div class="optionitem item_name">所在地区：</div>
                        <!-- <div class="optionitem item_detail" style="  background-color: #dcdfe6;
                        border-radius: 10px;"> 一般财产</div> -->
                      <div  class="optionitem item_detail" >
                            <el-select v-model="index2" placeholder="请选择" style="width:100%;" >
                                <el-option
                                    v-for="item in kind2"
                                    :key="item"
                                    :value="item">
                                </el-option>
                            </el-select>
    
    
    
                        </div>
    
                    </div>  

                <div  style="margin-top:60px">
                    <!-- <button @click="alert('ok')" type="button">Click Me!</button>
                    <button type="button">Cancle!</button> -->
                    <el-row>

                        <el-button @click="newcal" type="primary">确定</el-button>
                        <el-button @click="resetEvent" type="warning" style="margin-left: 50px;">清空</el-button>
                
                    </el-row>
                </div>

                <div class="result">
                    <h4>计算结果：</h4>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;计算结果：{{fee}}  </p>
                    <p  style="font-weight:500;margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;计算结果仅供参考，参考来源：各地律师法律服务收费行业指导标准、《中华人民共和国律师法》、各地收费管理办法等。&nbsp;&nbsp; 数据来源《诉讼费用缴纳办法》</p>
                    <p v-if="tips">{{tips}}</p>
                   
                    <!-- <p>{{inputValue}}</p> -->


                    <el-table
                        v-if="caseType==2"
                        :data="arr"
                        stripe
                        style="width: 90%">
                        
                        
                        <el-table-column
                            prop="name"
                            label="金额区间"
                        >

                        <template slot-scope="scope" >
                            <!-- <span>{{scope.$index}}</span> -->
                            <span>  {{scope.$index==arr.length-1? scope.row.amount+'以上' :  scope.row.amount + "-" + arr[scope.$index+1].amount   }}</span>
                        </template>

                        </el-table-column>
                      
                        <el-table-column
                            prop="ratio"
                            label="费率（区间）"
                        >

                        <template slot-scope="scope" >
                            <span v-if="scope.row.range">  {{ scope.row.range[0]}}元 ~ {{ scope.row.range[1]}}元     </span>
                            <span v-else>   {{ scope.row.ratio[0]!=scope.row.ratio[1]? scope.row.ratio[0]+'-' +scope.row.ratio[1]: scope.row.ratio[0]  }}    </span>
                        </template>

                        
                        </el-table-column>
                        
                        <el-table-column
                        prop="capital"
                        label="计算金额">

                            <!-- <template slot-scope="scope" >
                                <span v-if="scope.row.capital"> {{scope.row.capital }} </span>
                            </template> -->
                        </el-table-column>

                        <el-table-column
                        prop="amount"
                        label="费用">
                        <template slot-scope="scope" >
                            <span  >  {{scope.row.min || scope.row.min==0 ? scope.row.min :''  }}   {{scope.row.max && scope.row.max!=scope.row.min? "-"+scope.row.max:'' }}     </span>
                            
                        </template>

                        </el-table-column>


        <!-- {{item.min || item.min==0 ? item.min :''  }}   {{item.max && item.max!=item.min? "-"+item.max:'' }}   -->

                    </el-table>



                    <div style="width:90%">
                  

                        <span  class="guide"  @click="check_article" > {{ refer }}</span>
                         <!-- @click="check_article" -->

                    </div> 


                </div>

            </div>   

        </div>

	
</template>

 


<script>

 


var filters = {
    toFix: function (value) {
        return value.toFixed(2)//此处2为保留两位小数
    }
} 

function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}




 var config= {
  "001": {
      "name": "江苏省",
      "civil": {
          'most': 10000,
          'least': 2500,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.06, 0.07] ,"range":[2500,10000] },
              {"amount": 10000, "ratio": [0.06, 0.07]  },
              {"amount": 100000, "ratio": [0.05, 0.06]},
              {"amount": 500000, "ratio": [0.04, 0.05]},
              {"amount": 1000000, "ratio": [0.03, 0.04]},
              {"amount": 5000000, "ratio": [0.02, 0.03]},
              {"amount": 10000000, "ratio": [0.01, 0.02]},
              {"amount": 100000000, "ratio": [0.005, 0.01]},
          ],
          "tips": ' 不涉及财产部分，按2500-10000元。重大、疑难案件不超过5倍收费'
      },
      "criminal": {
          "result": "侦察阶段：1000-8000 元 \n 审查起诉阶段：1500-10000 元\n 一审阶段：3000-20000 元 \n 重大、疑难、复杂案件：不超过基础价格的五倍 ",
          "tips": "被害人提起刑事附带民事诉讼案件的，按照涉及财产关系的民事诉讼案件政府指导价收费标准执行；"
      }
  },
  "002": {
      "name": "广东省",
      "civil": {
          'most': 20000,
          'least': 3000,
          "extra": [1000, 8000],
          "arr": [
              {"amount": 50000, "ratio": [0.08, 0.08]},
              {"amount": 100000, "ratio": [0.05, 0.05]},
              {"amount": 500000, "ratio": [0.04, 0.04]},
              {"amount": 1000000, "ratio": [0.03, 0.03]},
              {"amount": 5000000, "ratio": [0.02, 0.02]},
              {"amount": 10000000, "ratio": [0.01, 0.01]},
              {"amount": 50000000, "ratio": [0.005, 0.005]},
          ],
          "tips": '不涉及财产的民事、行政诉讼：3000-20000元/件 ，涉及财产的基础费用1000-8000，可以上下浮20%'
      },
      "criminal": {
          "result": "侦察阶段：1000-8000 元 \n 审查起诉阶段：1500-10000 元\n 一审阶段：3000-20000 元 \n 重大、疑难、复杂案件：不超过基础价格的五倍 ",
          "tips": "被害人提起刑事附带民事诉讼案件的，按照涉及财产关系的民事诉讼案件政府指导价收费标准执行；"
      }
  },
  "003": {
      "name": "浙江省",
      "civil": {
          'most': 8000,
          'least': 2500,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.06, 0.08]},
              {"amount": 100000, "ratio": [0.05, 0.06]},
              {"amount": 500000, "ratio": [0.04, 0.05]},
              {"amount": 1000000, "ratio": [0.03, 0.04]},
              {"amount": 5000000, "ratio": [0.02, 0.03]},
              {"amount": 10000000, "ratio": [0.01, 0.02]},
          ],
          "tips":'不涉及财产关系的民事诉讼案件：2500-10000元/件'
      },
      "criminal": {
          "result": "侦察阶段：1500-8000 元 \n 审查起诉阶段：1500-10000 元\n 一审阶段：2500-25000 元  ",
          "tips": ""
      }
  },
  "004": {
      "name": "北京市",
      "civil": {
          'most': 15000,
          'least': 3000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.1, 0.1]},
              {"amount": 100000, "ratio": [0.06, 0.06]},
              {"amount": 1000000, "ratio": [0.04, 0.04]},
              {"amount": 10000000, "ratio": [0.02, 0.02]},
          ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：2000-15000 元 \n 审查起诉阶段：2000-15000 元\n 一审阶段：4000-45000 元  ",
          "tips": ""
      }
  },
  "005": {
      "name": "上海市",
      "civil": {
          'most': 12000,
          'least': 3000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.08, 0.12]},
              {"amount": 100000, "ratio": [0.05, 0.07]},
              {"amount": 1000000, "ratio": [0.03, 0.05]},
              {"amount": 10000000, "ratio": [0.01, 0.03]},
              {"amount": 100000000, "ratio": [0.005, 0.01]},
          ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：1500-10000 元 \n 审查起诉阶段：2000-10000 元\n 一审阶段：3000-30000 元  ",
          "tips": ""
      }
  },
  "006": {
      "name": "广西省",
      "civil": {
          'most': 10000,
          'least': 1000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.05, 0.05]},
              {"amount": 100000, "ratio": [0.045, 0.045]},
              {"amount": 500000, "ratio": [0.04, 0.04]},
              {"amount": 1000000, "ratio": [0.03, 0.03]},
              {"amount": 5000000, "ratio": [0.02, 0.02]},
              {"amount": 10000000, "ratio": [0.01, 0.01]},

          ],
          "tips": '不涉及财产： 1000-10000元/件'
      },
      "criminal": {
          "result": "侦察阶段：2000-15000 元 \n 审查起诉阶段：2000-15000 元\n 基层法院：2000-20000 元\n 中级法院：3000-35000 元\n 高级法院：8000-50000 元\n 最高法院：30000-150000 元  ",
          "tips": ""
      }
  },
  "007": {
      "name": "山东省",
      "civil": {
          'most' : 12000,
          'least' : 2500,
          "extra": [2500, 3000],
          "arr": [
              {"amount": 10000, "ratio": [0.06, 0.09]},
              {"amount": 100000, "ratio": [0.05, 0.06]},
              {"amount": 500000, "ratio": [0.04, 0.05]},
              {"amount": 1000000, "ratio": [0.03, 0.04]},
              {"amount": 5000000, "ratio": [0.02, 0.03]},
          ],
          "tips": '500万以上无建议比例。最新文件已过期，费用报价不再做强制要求'
      },
      "criminal": {
          "result": "侦察阶段：1500-10000 元 \n 审查起诉阶段：2000-15000 元\n 一审阶段：2500-25000 元  ",
          "tips": "被害人提起刑事附带民事诉讼案件的，按照涉及财产关系的民事诉讼案件政府指导价收费标准执行；"
      }
  },

  "008": {
      "name": "福建省", //偏低
      "civil": {
          'most': 6000,
          'least': 800,
          "extra": [0, 0],
          "arr": [
            {"amount": 0, "ratio": [0.04, 0.04],'range':[800,6000]},
              {"amount": 100000, "ratio": [0.04, 0.04]},
              {"amount": 500000, "ratio": [0.03, 0.03]},
              {"amount": 1000000, "ratio": [0.02, 0.02]},
              {"amount": 5000000, "ratio": [0.012, 0.012]},
              {"amount": 10000000, "ratio": [0.007, 0.007]},
              {"amount": 50000000, "ratio": [0.005, 0.005]},

          ],
          "tips": '数额建议为”不超过“ '
      },
      "criminal": {
          "result": "侦察阶段：1000-10000 元 \n 审查起诉阶段：1000-12000 元\n 审判阶段：1500-23000 元\n ",
          "tips": ""
      }
  },

  "009": {
      "name": "四川省",
      "civil": {
          'most': 10000,
          'least': 1000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.06, 0.06]},
              {"amount": 100000, "ratio": [0.055, 0.055]},
              {"amount": 500000, "ratio": [0.05, 0.05]},
              {"amount": 1000000, "ratio": [0.04, 0.04]},
              {"amount": 5000000, "ratio": [0.03, 0.03]},
              {"amount": 10000000, "ratio": [0.02, 0.02]},


          ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：2000-15000 元 \n 审查起诉阶段：2000-12000 元\n 审判阶段：3000-30000 元\n ",
          "tips": ""
      }
  },
  "010": {
      "name": "河北省",
      "civil": {
          'most': 30000,
          'least': 3000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.08, 0.08]},
              {"amount": 100000, "ratio": [0.06, 0.06]},
              {"amount": 1000000, "ratio": [0.04, 0.04]},
              {"amount": 10000000, "ratio": [0.02, 0.02]},


          ],
          "tips": '不涉及财产的，可在3000元至30000元中议定'
      },
      "criminal": {
          "result": "侦察阶段：2000-6000 元 \n 审查起诉阶段：3000-9000 元\n 审判阶段：4000-12000 元\n ",
          "tips": ""
      }
  },

  "011": {
      "name": "河南省",
      "civil": {
          'most': 10000,
          'least': 2000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.03, 0.05] , "range":[3000,5000] },
              {"amount": 100000, "ratio": [0.03, 0.05]},
              {"amount": 1000000, "ratio": [0.02, 0.04]},
              {"amount": 10000000, "ratio": [0.01, 0.03]},
              {"amount": 50000000, "ratio": [0.005, 0.02]},

          ],
          "tips": '不涉及财产的，可在3000元至30000元中议定'
      },
      "criminal": {
          "result": "侦察阶段：3000-15000 元 \n 审查起诉阶段：5000-20000 元\n 审判阶段：5000-30000 元\n ",
          "tips": ""
      }
  },

  "012": {
      "name": "辽宁省",
      "civil": {
          'most': 30000,
          'least': 5000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.08, 0.1]},
              {"amount": 100000, "ratio": [0.07, 0.09]},
              {"amount": 500000, "ratio": [0.06, 0.08]},
              {"amount": 1000000, "ratio": [0.05, 0.07]},
              {"amount": 5000000, "ratio": [0.04, 0.06]},
              {"amount": 10000000, "ratio": [0.03, 0.05]},
              {"amount": 20000000, "ratio": [0.02, 0.04]},
              {"amount": 50000000, "ratio": [0.01, 0.03]},

          ],
          "tips": '代理民商、行政申诉案件可参照一审阶段的收费标准收费，上浮不超过150％。'
      },
      "criminal": {
          "result": "侦察阶段：8000 元 \n 审查起诉阶段：8000 元\n 审判阶段：8000 元\n ",
          "tips": ""
      }
  },

  "013": {
      "name": "黑龙江省", //严重偏低
      "civil": {
          'most': 1000,
          'least': 200,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.03, 0.03]},
              {"amount": 100000, "ratio": [0.02, 0.02]},
              {"amount": 500000, "ratio": [0.01, 0.01]},
              {"amount": 1000000, "ratio": [0.005, 0.005]},
              {"amount": 5000000, "ratio": [0.002, 0.002]},


          ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：1500 元 \n 审查起诉阶段：2000 元\n 审判阶段：3000 元 \n 以上可根据情况上浮40%",
          "tips": ""
      }
  },


  "015": {
      "name": "重庆市",
      "civil": {
          'most': 6000,
          'least': 2000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.02, 0.06], "range":[2000,10000] },
              {"amount": 100000, "ratio": [0.04, 0.05]},
              {"amount": 1000000, "ratio": [0.03, 0.04]},
              {"amount": 5000000, "ratio": [0.02, 0.03]},
              {"amount": 10000000, "ratio": [0.01, 0.02]},
              {"amount": 50000000, "ratio": [0.005, 0.01]},
          ],
          "tips": '不涉及财产关系的，实行计件收费，每件收取2000—10000元'
      },
      "criminal": {
          "result": "侦察阶段：2000-10000 元 \n 审查起诉阶段：2000-10000 元\n 审判阶段：3000-30000 元",
          "tips": ""
      }
  },

  "016": {
      "name": "安徽省",
      "civil": {
          'most': 8000,
          'least': 1000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.02, 0.08] , "range":[1000,8000]  },
              {"amount": 100000, "ratio": [0.04, 0.06]},
              {"amount": 500000, "ratio": [0.03, 0.05]},
              {"amount": 1000000, "ratio": [0.02, 0.04]},
              {"amount": 5000000, "ratio": [0.01, 0.03]},
              {"amount": 10000000, "ratio": [0.01, 0.02]},
          ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：1200-8000 元 \n 审查起诉阶段：1200-8000 元\n 审判阶段：1200-15000 元",
          "tips": ""
      }
  },
  "017": {
      "name": "湖北省",
      "civil": {
          'most': 8000,
          'least': 600,
          "extra": [600, 8000],
          "arr": [
      
              {"amount": 100000, "ratio": [0.01, 0.05]},
              {"amount": 1000000, "ratio": [0.005, 0.03]},
              {"amount": 5000000, "ratio": [0.003, 0.02]},
              {"amount": 10000000, "ratio": [0.002, 0.015]},
              {"amount": 50000000, "ratio": [0.001, 0.01]},
          ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：1000-5000 元 \n 审查起诉阶段：1000-5000 元\n 审判阶段：1000-10000 元\n 经济类、共同犯罪案件上限可以增加5000 ",
          "tips": ""
      }
  },

  "018": {
      "name": "湖南省",
      "isDone": 0,
      "civil": {
        'most': 10000,
        'least': 3000,
        "extra": [0, 0],
        "arr": [
            {"amount": 0, "ratio": [0.02, 0.08], "range": [3000, 10000]},
            {"amount": 100000, "ratio": [0.06, 0.08]},
            {"amount": 500000, "ratio": [0.04, 0.06]},
            {"amount": 5000000, "ratio": [0.02, 0.04]},
            {"amount": 20000000, "ratio": [0.01, 0.02]},
            {"amount": 100000000, "ratio": [0.005, 0.01]},

        ],
          "tips": '对经济欠发达地区、特别困难的单位或个人，可在上述比例降低30%的幅度以内适当收费'
      },
      "criminal": {
          "result": "侦察阶段：1000-10000 元 \n 审查起诉阶段：1000-10000 元\n 审判阶段一审：2000-20000 元\n 审判阶段二审：2000-30000 元  ",
          "tips": ""
      }
  },
  "019": {
      "name": "海南省",

      "civil": {
        'most': 8000,
        'least': 2000,
        "extra": [0, 0],
        "arr": [
            {"amount": 0, "ratio": [0.08, 0.08] },
            {"amount": 100000, "ratio": [0.07, 0.07]},
            {"amount": 500000, "ratio": [0.06, 0.06]},
            {"amount": 1000000, "ratio": [0.05, 0.05]},
            {"amount": 5000000, "ratio": [0.04, 0.04]},
            {"amount": 10000000, "ratio": [0.03, 0.03]},
            {"amount": 50000000, "ratio": [0.02, 0.02]},
            {"amount": 100000000, "ratio": [0.01, 0.01]},

        ],
        "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：2000-20000 元 \n 审查起诉阶段：3000-30000 元\n 审判阶段一审(基层法院)：2000-20000 元\n  审判阶段一审(中级法院)：5000-50000 元 ",
          "tips": ""
      }
  },

  "020": {
      "name": "天津市",
      "civil": {
        'most': 30000,
        'least': 3000,
        "extra": [0, 0],
        "arr": [
      
          {"amount": 0, "ratio": [0.08, 0.08],   },
          {"amount": 100000, "ratio": [0.06, 0.06]},
          {"amount": 1000000, "ratio": [0.04, 0.04]},
          {"amount": 10000000, "ratio": [0.02, 0.02]},


        ],
        "tips": '对于重大、疑难、复杂诉讼案件，可以在上述收费标准基础上上浮100%-500%'
      },
      "criminal": {
          "result": "侦察阶段：3000 元 \n 审查起诉阶段：3000 元\n 审判阶段一审：6000 元\n  审判阶段二审：6000 元 ",
          "tips": ""
      }
  },
  "021": {
      "name": "山西省",
      "civil": {
          'most': 6000,
          'least': 2000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.06, 0.06],   },
              {"amount": 100000, "ratio": [0.05, 0.05]},
              {"amount": 500000, "ratio": [0.04, 0.04]},
              {"amount": 1000000, "ratio": [0.03, 0.03]},
              {"amount": 5000000, "ratio": [0.02, 0.02]},
              {"amount": 10000000, "ratio": [0.015, 0.015]},
              {"amount": 50000000, "ratio": [0.01, 0.01]},
          ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：2000-20000 元 \n 审查起诉阶段：2000-20000 元\n 审判阶段：3000-35000 元\n   ",
          "tips": ""
      }
  },
  "022": {
      "name": "陕西省",
      "civil": {
          'most': 5000,
          'least': 500,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.06, 0.06], "range": [1000, 1000]}, 
              {"amount": 10000, "ratio": [0.05, 0.05], },
              {"amount": 500000, "ratio": [0.04, 0.04]},
              {"amount": 1000000, "ratio": [0.03, 0.03]},
              {"amount": 5000000, "ratio": [0.02, 0.02]},
              {"amount": 10000000, "ratio": [0.01, 0.01]},
              {"amount": 50000000, "ratio": [0.005, 0.005]},
          ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：500-5000 元 \n 审查起诉阶段：1000-5000 元\n 审判阶段：10000-30000 元\n   ",
          "tips": ""
      }
  },

  "023": {
      "name": "云南省",
      "civil": {
          'most': 5000,
          'least': 5000,
          "extra": [0, 0],
          "arr": [
            {"amount": 0, "ratio": [0.05, 0.05],  }, 
            {"amount": 100000, "ratio": [0.042, 0.042], },
            {"amount": 500000, "ratio": [0.04, 0.04]},
            {"amount": 1000000, "ratio": [0.03, 0.03]},
            {"amount": 5000000, "ratio": [0.02, 0.02]},
            {"amount": 10000000, "ratio": [0.012, 0.012]},
            {"amount": 20000000, "ratio": [0.01, 0.01]},
            {"amount": 50000000, "ratio": [0.005, 0.005]},
          ],
          "tips": '不涉及财产关系的，收费标准为5,000元-30,000元'
      },
      "criminal": {
          "result": "未找到相关文件",
          "tips": ""
      }
  },

  "024": {
      "name": "江西省",
      "isDone": 0,
      "civil": {
          'most': 6000,
          'least': 1000,
          "extra": [1000, 6000],
          "arr": [
              {"amount": 50000, "ratio": [0.015, 0.05], },
              {"amount": 100000, "ratio": [0.012, 0.04]},
              {"amount": 1000000, "ratio": [0.01, 0.03]},
              {"amount": 5000000, "ratio": [0.005, 0.02]},
              {"amount": 10000000, "ratio": [0.002, 0.015]},
              {"amount": 50000000, "ratio": [0.001, 0.01]},
          ],
          "tips": '不涉及财产关系的1000--6000元/件'
      },
      "criminal": {
          "result": "侦察阶段：8500-5000 元 \n 审查起诉阶段：800-5000 元\n 审判阶段：16000-15000 元\n   ",
          "tips": ""
      }
  },

  "025": {
      "name": "吉林省",
      "civil": {
          'most': 6000,
          'least': 2000,
          "extra": [0, 0],
          "arr": [ //最大比例可上浮30%
            {"amount": 0, "ratio": [0.08, 0.1], 'range':[5000,10000] },
            {"amount": 100000, "ratio": [0.07, 0.09]},
            {"amount": 500000, "ratio": [0.06, 0.08]},
            {"amount": 1000000, "ratio": [0.05, 0.07]},
            {"amount": 5000000, "ratio": [0.04, 0.06]},
            {"amount": 10000000, "ratio": [0.03, 0.05]},
            {"amount": 20000000, "ratio": [0.02, 0.04]},
            {"amount": 50000000, "ratio": [0.01, 0.03]},
          ],
          "tips": '不涉及财产关系的，基准收费标准为5000元-2000元/件，上浮最高不超过100%'
      },
      "criminal": {
          "result": "侦察阶段：2000 元 \n 审查起诉阶段：3000 元\n 审判阶段：5000 元\n   ",
          "tips": ""
      }
  },
  "026": {
    "name": "西藏",
    "civil": {
        'most': 20000,
        'least': 2000,
        "extra": [0, 0],
        "arr": [
            {"amount": 0, "ratio": [0.05, 0.06], },
            {"amount": 100000, "ratio": [0.04, 0.05]},
            {"amount": 1000000, "ratio": [0.03, 0.04]},
            {"amount": 5000000, "ratio": [0.02, 0.03]},
            {"amount": 10000000, "ratio": [0.01, 0.02]},
            {"amount": 50000000, "ratio": [0.005, 0.01]},
        ],
        "tips": ''
    },
    "criminal": {
        "result": "侦察阶段：2000-10000 元 \n 审查起诉阶段：2000-15000 元\n 审判阶段：5000-25000 元\n 担任自诉人、被害人的诉讼代理人：2000元～20000元／件。  ",
        "tips": ""
    }
  },
  "027": { 
      "name": "贵州省",
      "civil": {
        'most': 5000,
        'least': 5000,
        "extra": [0, 0],
        "arr": [
            {"amount": 0, "ratio": [0.06, 0.07], },

            {"amount": 100000, "ratio": [0.05, 0.06]},
            {"amount": 1000000, "ratio": [0.04, 0.05]},
            {"amount": 5000000, "ratio": [0.03, 0.04]},
            {"amount": 10000000, "ratio": [0.01, 0.02]},
            {"amount": 50000000, "ratio": [0.005, 0.01]},
        ],
          "tips": ''
      },
      "criminal": {
          "result": "侦察阶段：500-3000 元 \n 审查起诉阶段：500-3000 元\n 审判阶段：1000-5000 元\n   ",
          "tips": ""
      }
  },
  "028": {
      "name": "甘肃省",
      "civil": {
          'most': 50000,
          'least': 5000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.08, 0.1] },
              {"amount": 100000, "ratio": [0.07, 0.09]},
              {"amount": 500000, "ratio": [0.06, 0.08]},
              {"amount": 1000000, "ratio": [0.05, 0.07]},
              {"amount": 5000000, "ratio": [0.04, 0.06]},
              {"amount": 10000000, "ratio": [0.03, 0.05]},
              {"amount": 50000000, "ratio": [0.02, 0.04]},
              {"amount": 100000000, "ratio": [0.01, 0.02]},
          ],
          "tips": '不涉及财产关系的，可以计件收费。每件收费数额可在5000元至50000元幅度内由律师事务所与委托人协商确定。首次代理的案件，再次代理的，可以在本标准20%一30%范围内给予下浮优惠'
      },
      "criminal": {
          "result": "暂无相关指引文件参考，欢迎联系客服提供线索",
          "tips": ""
      }
  },
  "029": {
      "name": "新疆",
      "isDone": 0,
      "civil": {
          'most': 10000,
          'least': 3000,
          "extra": [0, 0],
          "arr": [
              {"amount": 0, "ratio": [0.1, 0.1] ,'extra':[0,0] },
              {"amount": 100000, "ratio": [0.08, 0.08] ,'extra':[2000,2000] },
              {"amount": 500000, "ratio": [0.06, 0.06],'extra':[12000,12000] },
              {"amount": 1000000, "ratio": [0.05, 0.05],'extra':[22000,22000] },
              {"amount": 5000000, "ratio": [0.04, 0.04],'extra':[72000,72000] },
              {"amount": 10000000, "ratio": [0.02, 0.02],'extra':[272000,272000] },
              {"amount": 50000000, "ratio": [0.01, 0.01],'extra':[772000,772000] },
              {"amount": 100000000, "ratio": [0.005, 0.005],'extra':[1272000,1272000] },
          ],
          "tips": ''
      },
      "criminal": {
          "result": "暂无相关指引文件参考，欢迎联系客服提供线索",
          "tips": ""
      }
  },
  "default": {
      "name": "",
      "civil": {
          'most': 10000,
          'least': 2500,
          "extra": [0, 0],
          "arr": [
              {"amount": 10000, "ratio": [0.06, 0.07]},
              {"amount": 100000, "ratio": [0.05, 0.06]},
              {"amount": 500000, "ratio": [0.04, 0.05]},
              {"amount": 1000000, "ratio": [0.03, 0.04]},
              {"amount": 5000000, "ratio": [0.02, 0.03]},
              {"amount": 10000000, "ratio": [0.01, 0.02]},
              {"amount": 100000000, "ratio": [0.005, 0.01]},
          ],
          "tips": '未找到本地区的指引文件，这里以江苏省标准为参考文件，欢迎提供文件信息线索供我们完善'
      },
      "criminal": {
          "result": "侦察阶段：1000-8000 元 \n 审查起诉阶段：1500-10000 元\n 一审阶段：3000-20000 元 \n 重大、疑难、复杂案件：不超过基础价格的五倍 ",
          "tips": "未找到本地区的指引文件，这里以江苏省标准为参考文件，欢迎提供文件信息线索供我们完善"
      }
  },
  "version":'1.0'

};


 import { IncUseNumber } from '@/assets/js/cal/cal';  

 import consult from '@/components/ads/consult.vue' 

	export default {
        metaInfo: {
            title: '律师费计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '律师费查询,律师费计算,律师工具,咨询律师,法律咨询,免费法律咨询'
            }],
      
        },
		name: 'lawyerfee',
        // props: {
        //     isPhone: Boolean
        // },
        components: { 
            consult
        
        },
        data() {
			return { 
                kind: ['民事案件', '刑事案件' ],
                index:'民事案件',
                index2:"江苏省",
                
                kind2: ['江苏省', '广东省', '浙江省', '北京市', '上海市', '广西省', '山东省', '福建省', '四川省', '河北省', '河南省', '辽宁省', '黑龙江省', '内蒙古', '重庆市', '安徽省', '湖北省', '湖南省', '海南省', '天津市', '山西省', '陕西省(西安标准)',  '云南省','江西省' ,'吉林省','西藏', '贵州省', '甘肃省', '青海省', '宁夏', '新疆' ],
    
                
                inputValue:'',
                fee:'',
                result1:0,
                result2:0,
                halfleft:"halfyes",    
                halfright: "halfno",
                ishalf:'1',

                screenWidth:window.innerWidth,
                screenHeight:window.innerHeight,
                isPhone:false,


                code:{
                    '江苏省':'001' ,   '上海市':'005' , '广东省':'002' ,   '浙江省':'003' ,  '山东省':"007", '北京市':'004' ,    '广西省':'006' , 
                    '福建省':'008' ,'四川省':'009' ,   '河北省':'010' ,  '河南省':'011' , '辽宁省':'012' ,    '黑龙江省':'013' ,  
                    '重庆市':'015' ,'安徽省':'016' ,   '湖北省':'017' , '湖南省':'018' ,  '海南省':'019' ,  '天津市':'020' ,
                    '山西省':'021' ,  '陕西省':'022' , '云南省':'023' , '江西省':'024' ,  '吉林省':'025' ,     '贵州省':'027' ,
                    '甘肃省':'028' ,  '新疆':'029' ,  '西藏':'026' ,
                    // '内蒙古':'014' ,    '青海省':'030' ,'宁夏':'031' ,
                },
                arr:[],
                extra:'',
                least:'',
                most:'',
                tips:'',
                caseType:'',

                refer:'查看指导文件',
                areaLink:{
                    '江苏省':'jcap9560747415' ,  
                    '上海市':'e2rd9551561665' ,
                    '广东省':'uxh69561034220' ,  
                    '浙江省':'go2o9561459134' ,
                    '山东省':"4opr9514912680",
                    '北京市':'jcap9560747415' ,  
                    '广西省':'' , 
                    '福建省':'' ,
                    '四川省':'jcap9560747415' ,  
                    '河北省':'' ,
                    '辽宁省':'jcap9560747415' ,  
                    '黑龙江省':'' ,
                    '内蒙古':'jcap9560747415' ,  
                    '重庆市':'' ,
                    '安徽省':'jcap9560747415' ,  
                    '湖北省':'' ,
                },
                // result:{
                //     arr:[]
                // }
                


            }

        },
        mounted(){
            this.GetPubInfo()
            this.isPhone=isphone()
            IncUseNumber('lawyerfee')
        },
        
        methods:{
            GetPubInfo(){
                var that=this 
                var data={
                    timestamp: Math.ceil(Math.random()*10)+'csaw213123',  
                }
                this.axios.get( 'https://www.lawtip.cn/fee/lawyer_fee_config' ,data //https://11law.lawtip.cn/php/publicinfo/lawyer_fee.json?
                ).then(function (res) {
                
                     
                    let result=res.data  
                    console.log("result:",result)
                 
                    that.areaLink=result.areaLink
 
                    let link=that.index2   
                    if(!link){
                   
                        that.refer='暂无指导文件'
                    }else{
                      
                        that.refer='查看指导文件'
                    }
                
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                
                });

            },

            check_article(){

                let area=this.index2
                let areaLink=this.areaLink
                let link=areaLink[area]  
                // console.log('link:',link)

                // https://www.lawtip.cn/community/jcap9560747415

                // link: /pages/news/article?id=jcap9560747415
              
                if(link){
                    link=link.split("id=")[1]
                    // console.log('link2:',link)
                    // wx.navigateTo({
                    //     url: link,
                    // })
                    window.open('https://www.lawtip.cn/community/'+link)

                }else{
                    this.$message({
                        type: 'info',
                        message:'对不起,该地区暂时未找到相应文件',
                        showClose: true,
                        duration:3000,
                    });
                }
            },

        bindhalf1:function(){
            this.halfleft='halfno';
            this.halfright='halfyes';
            this.half_bg1='width:60px;background-color: #dddddd;height:30px;';
            this.half_bg2='margin-left:120px;width:60px;height:30px; ';
             

        },

        bindhalf2: function () {
            this.halfleft='halfyes';
            this.halfright='halfno';
            this.half_bg1='width:60px;height:30px;';
            this.half_bg2='margin-left:120px;width:60px;height:30px; background-color: #dddddd;';
             
      
        },
   
        bindPickerChange(e){
            this.index=e.detail.value;
 
        },
        resetEvent(){
          this.fee='';
          this.inputValue='';
        },

        newcal(){
             
            var that = this;
            var item1 =  that.index //parseInt(that.data.index)
            // var item2 = parseInt(that.data.index2)
            var t = that.inputValue || 0 ;

            console.log('t:',t)

            var arr 
            var len 
        
            var min=0
            var max=0 
            var most,least 
            var extra 
            var fee  
            var tips=''
            t=parseFloat(t);
        
            var area= this.index2  //this.data.kind2[item2]


            console.log('area:',area)
            
            var code=this.code[area] || 'default' 
            console.log('code:',code)
            // var obj=config[code]

            let obj=JSON.parse(JSON.stringify(config[code]))

            console.log('obj:',obj)
           
            // this.setData({
            //     obj:obj 
            // })

            if(item1=='民事案件'){
                this.arr=[]
               
                obj=obj.civil
                arr=obj.arr 
                extra=obj.extra 
                least=obj.least
                most=obj.most

                len=arr.length 
                for(let i=len-1;i>=0;i--){
                    if(t<=arr[i].amount){
                        // console.log('continue,amount:',arr[i].amount)
                        continue
                    }else{
                        if(arr[i].range){
                            arr[i].min=arr[i].range[0]
                            arr[i].max=arr[i].range[1]
                        }else{
                            arr[i].min=(t-arr[i].amount)*arr[i].ratio[0] 
                            arr[i].max=(t-arr[i].amount)*arr[i].ratio[1] 
                            // if(arr[i].extra ){
                            //   arr[i].min= arr[i].min+arr[i].extra[0]
                            //   arr[i].max= arr[i].max+arr[i].extra[1]
                            // }
                
                            arr[i].min= parseFloat(filters.toFix(arr[i].min) )
                            arr[i].max= parseFloat(filters.toFix(arr[i].max) )


                        }

                

                        min=min+arr[i].min
                        max=max+arr[i].max
                        arr[i].capital=t-arr[i].amount

                        console.log('-------------------------------------------')

                        console.log('arr[i].capital:',arr[i].capital,'   t:',t,'  arr[i].amount:',arr[i].amount)

                        console.log('-------------------------------------------')

                        t=arr[i].amount
                
                    }
                }

                min = Math.max(min+extra[0], least);
                max = Math.max(max+extra[1], most);
                // min = Math.max(min , least);
                // max = Math.max(max , most);
                min=filters.toFix(min)
                max=filters.toFix(max)
                console.log('min:',min,'max:',max )
                // console.log('min:',min,'max:',max ) 
                console.log("arr:",arr)
                if(min!=max){
                    fee=min+'~'+max+'元'
                } else{
                    fee=min+'元'
                }
         
                this.arr=arr

                // this.$set(this.result,'arr',arr);

                this.fee=fee 
                this.extra=extra 
                this.least=least
                this.most=most 
                this.tips=obj.tips
                this.caseType=2


            } else if (item1 == '刑事案件') {
                obj=obj.criminal
         
                this.caseType=1
                this.tips=obj.tips
                this.fee=obj.result

            }


        },

        bindcalculate: function () {

            var t = this.inputValue;
            // var that = this;

            t=parseFloat(t);
            // var x = 0;
            var xmin = 0;
            var xmax = 0;
            var most=0;
            var least=0;
            var r1=0,r2=0,r3=0,r4=0,r5=0,r6=0,r7=0,r8=0;
            // var z1,z2;
            var x1,x2,x3,x4,x5,x6,x7,x8,y1,y2,y3,y4,y5,y6,y7,y8;
            // var imin;
            // var imax;
            var result;

            if(this.index=='民事案件'){
            switch (this.index2) {
                case '江苏省':    
                most = 10000; least = 2500;
                r1 = 0; r2 = 10000; r3 = 100000; r4 = 500000; r5 = 1000000; r6 = 5000000; r7 = 10000000; r8 = 100000000; 
                x1 = 0, y1 =0; x2 = 0.06; y2 = 0.07; x3 = 0.05; y3 = 0.06; x4 = 0.04; y4 = 0.05; x5 = 0.03; y5 = 0.04;x6=0.02;y6=0.03;x7=0.01,y7=0.02;x8=0.005;y8=0.01;
                break;

                case '广东省':      
                most = 8000; least = 1000;
                r1 = 0; r2 = 50000; r3 = 100000; r4 = 500000; r5 = 1000000;
                r6 = 5000000; r7 = 10000000; r8 = 50000000; 

                x1 = 0, y1 = 0; x2 = 0.08; y2 = 0.08; x3 = 0.05; y3 = 0.05; x4 = 0.04; y4 = 0.04; x5 = 0.03; y5 = 0.03; x6 = 0.02; y6 = 0.02; x7 = 0.01, y7 = 0.01; x8 = 0.005; y8 = 0.005;

                break;

                case '浙江省':     
            
                most = 10000; least = 2500;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000;
                r6 = 10000000; 

                // x1 = 0, y1 = 0; x2 = 0.04; y2 = 0.048; x3 = 0.032; y3 = 0.04; x4 = 0.024; y4 = 0.032; x5 = 0.016; y5 = 0.024; x6 = 0.008; y6 = 0.016; 
                
                x1 = 0.06, y1 = 0.08; x2 = 0.05; y2 = 0.06; x3 = 0.04; y3 = 0.05; x4 = 0.03; y4 = 0.04; x5 = 0.02; y5 = 0.03; x6 = 0.01; y6 = 0.02; 
                
            
                break;

                case '北京市':      

                most = 10000; least = 3000;
                r1 = 0; r2 = 100000; r3 = 1000000; r4 = 10000000;

                x1 = 0, y1 = 0; x2 = 0.06; y2 = 0.06; x3 = 0.04; y3 = 0.04; x4 = 0.02; y4 = 0.02; 

                
                break;

                case '上海市':     
                most=3000;
                least=3000;
                r1 = 0; r2 = 100000; r3 = 1000000; r4 = 10000000; r5 = 100000000;
                x1 = 0.08, y1 = 0.12; x2 = 0.05; y2 = 0.07; x3 = 0.03; y3 = 0.05; x4 = 0.01; y4 = 0.03; x5 = 0.005; y5 = 0.01;
                break;

                case '广西省':     

                most = 10000; least = 1000;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000; r6 = 10000000;

                // x1 = 0, y1 = 0; x2 = 0.05; y2 = 0.05; x3 = 0.045; y3 = 0.045; x4 = 0.04; y4 = 0.04;x5=0.03;y5=0.03;x6=0.02;y6=0.02;x7=0.01;y7=0.01; 

x1 = 0.05, y1 = 0.05; x2 = 0.045; y2 = 0.045; x3 = 0.04; y3 = 0.04; x4 = 0.03; y4 = 0.03;x5=0.02;y5=0.02;x6=0.01;y6=0.01;  
            
                break;

                case '山东省':     

                most = 12000; least = 2500;
                r1 = 0; r2 = 10000; r3 = 100000; r4 = 500000; r5 = 1000000; r6 = 5000000;

                x1 = 0, y1 = 0; x2 = 0.06; y2 = 0.09; x3 = 0.05; y3 = 0.06; x4 = 0.04; y4 = 0.05; x5 = 0.03; y5 = 0.04; x6 = 0.02; y6 = 0.03;  

                
                break;

                case '福建省':      

                most = 10000; least = 4000;
                r1 = 0; r2 = 10000; r3 = 100000; r4 = 5000000; r5 = 10000000; r6 = 50000000;

                x1 = 0, y1 = 0; x2 = 0.08; y2 = 0.09; x3 = 0.06; y3 = 0.08; x4 = 0.04; y4 = 0.06; x5 = 0.02; y5 = 0.04; x6 = 0.01; y6 = 0.02; x7 = 0.005; y7 = 0.01;  

            
                break;

                case '四川省':     

                most = 10000; least = 1000;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000; r6 = 10000000;

                x1 = 0.06, y1 = 0.06; x2 = 0.055; y2 = 0.055; x3 = 0.05; y3 = 0.05; x4 = 0.04; y4 = 0.04; x5 = 0.03; y5 = 0.03; x6 = 0.02; y6 = 0.02; 

                
                break;

                case '河北省':      

                most = 3000; least = 3000;
                r1 = 0; r2 = 100000; r3 = 1000000; r4 = 10000000; 

                x1 = 0.08, y1 = 0.08; x2 = 0.06; y2 = 0.06; x3 = 0.04; y3 = 0.04; x4 = 0.02; y4 = 0.02;

            

                break;


                case '河南省':      

                most = 10000; least = 2000;
                r1 = 0; r2 = 100000; r3 = 1000000; r4 = 10000000; r5 = 50000000;

                x1 = 0.03, y1 = 0.05; x2 = 0.03; y2 = 0.05; x3 = 0.02; y3 = 0.04; x4 = 0.01; y4 = 0.03; x5 = 0.005; y5 = 0.02;

                break;

                case '辽宁省':    //mark
                most = 5000; least = 5000;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000; r6 = 10000000; r7 = 20000000; r8 = 50000000;

                x1 = 0.08, y1 = 0.1; x2 = 0.07; y2 = 0.09; x3 = 0.06; y3 = 0.08; x4 = 0.05; y4 = 0.07; x5 = 0.04; y5 = 0.06; x6 = 0.03; y6 = 0.05; x7 = 0.02; y7 = 0.04; x8 = 0.01; y8 = 0.03;
                    

                break; 


                case '黑龙江省':   
                most = 800; least = 800;
                r1 = 0; r2 = 20000; r3 = 100000; r4 = 500000; r5 = 1000000;r6=5000000;r7=10000000;r8=50000000; 

                x1 = 0, y1 = 0; x2 = 0.04; y2 = 0.04; x3 = 0.03; y3 = 0.03; x4 = 0.02; y4 = 0.02; x5 = 0.01; y5 = 0.01; x6 = 0.005; y6 = 0.005; x7 = 0.0025; y7 = 0.0025; x8 = 0.0015; y8 = 0.0015; 


                break; 
                case '内蒙古省':   
                most = 1000; least = 1000;
                r1 = 0; r2 = 10000; r3 = 100000; r4 = 500000; r5 = 1000000; r6 = 5000000; r7 = 10000000; r8 = 50000000;

                x1 = 0, y1 = 0; x2 = 0.05; y2 = 0.06; x3 = 0.04; y3 = 0.05; x4 = 0.03; y4 = 0.04; x5 = 0.02; y5 = 0.03; x6 = 0.01; y6 = 0.02; x7 = 0.005; y7 = 0.01; x8 = 0.005; y8 = 0.005;


                break;   

                case '重庆市':    
                most = 10000; least = 2000;
                r1 = 0; r2 = 100000; r3 = 1000000; r4 = 5000000; r5 = 10000000; r6 = 50000000;

                x1 = 0, y1 = 0; x2 = 0.04; y2 = 0.05; x3 = 0.03; y3 = 0.04; x4 = 0.02; y4 = 0.03; x5 = 0.01; y5 = 0.02; x6 = 0.005; y6 = 0.01; 


                break;   


                case '安徽省':    
                most = 8000; least = 1000;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000; r6 = 10000000;

                x1 = 0, y1 = 0; x2 = 0.04; y2 = 0.06; x3 = 0.03; y3 = 0.05; x4 = 0.02; y4 = 0.04; x5 = 0.01; y5 = 0.03; x6 = 0.01; y6 = 0.02;


                break;    

                case '湖北省':   
                most = 8000; least = 600;
                r1 = 0; r2 = 100000; r3 = 1000000; r4 = 5000000; r5 = 10000000; r6 = 50000000;

                x1 = 0, y1 = 0; x2 = 0.01; y2 = 0.05; x3 = 0.005; y3 = 0.03; x4 = 0.003; y4 = 0.02; x5 = 0.002; y5 = 0.015; x6 = 0.001; y6 = 0.01;


                break;     

                case '湖南省':   
                most = 10000; least = 3000;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 5000000; r5 = 20000000; r6 = 100000000;

                x1 = 0, y1 = 0; x2 = 0.06; y2 = 0.08; x3 = 0.04; y3 = 0.06; x4 = 0.02; y4 = 0.04; x5 = 0.01; y5 = 0.02; x6 = 0.005; y6 = 0.01;


                break;  

                case '海南省':    
                most = 2000; least = 2000;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000; r6 = 10000000; r7 = 50000000;

                x1 = 0.06, y1 = 0.06; x2 = 0.05; y2 = 0.05; x3 = 0.04; y3 = 0.04; x4 = 0.03; y4 = 0.03; x5 = 0.02; y5 = 0.02; x6 = 0.01; y6 = 0.01; x7 = 0.005; y7 = 0.005;


                break;   


                case '天津市':    
                most = 3000; least = 3000;
                r1 = 0; r2 = 100000; r3 = 1000000; r4 = 10000000; 
                x1 = 0.08, y1 = 0.08; x2 = 0.06; y2 = 0.06; x3 = 0.04; y3 = 0.04; x4 = 0.02; y4 = 0.02;


                break;   


                case '山西省':   //山西
                most = 2000; least = 2000;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000;
                r6 = 10000000; r7 = 50000000;
                x1 = 0.06, y1 = 0.06; x2 = 0.05; y2 = 0.05; x3 = 0.04; y3 = 0.04; x4 = 0.03; y4 = 0.03; x5 = 0.02; y5 = 0.02; x6 = 0.015; y6 = 0.015;
                x7= 0.01; y8=0.01;

                break; 

                case '陕西省':   //陕西
                most = 1000; least = 1000;
                r1 = 0; r2 = 10000; r3 = 500000; r4 = 1000000; r5 = 5000000;
                r6 = 10000000; r7 = 50000000;
                x1 = 0, y1 = 0; x2 = 0.05; y2 = 0.05; x3 = 0.04; y3 = 0.04; x4 = 0.03; y4 = 0.03; x5 = 0.02; y5 = 0.02; x6 = 0.01; y6 = 0.01;
                x7 = 0.005; y8 = 0.005;

                break; 

                case '云南省':   //云南
                most = 30000; least = 5000;
                r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000;
                r6 = 10000000; r7 = 20000000; r8 = 50000000;
                x1 = 0, y1 = 0; x2 = 0.05; y2 = 0.05; x3 = 0.042; y3 = 0.042; x4 = 0.03; y4 = 0.03; x5 = 0.02; y5 = 0.02; x6 = 0.012; y6 = 0.012;
                x7 = 0.01; y7 = 0.01; x8=0.005;  y8 = 0.005;

                break; 
                
                case '江西省':   //江西省
                most = 6000; least = 1000;
                r1 = 0; r2 = 50000; r3 = 100000; r4 = 1000000; r5 = 5000000;
                r6 = 10000000; r7 = 50000000; r8 = 50000000;
                x1 = 0, y1 = 0; x2 = 0.015; y2 = 0.05; x3 = 0.012; y3 = 0.04; x4 = 0.01; y4 = 0.03; x5 = 0.005; y5 = 0.02; x6 = 0.002; y6 = 0.015;
                x7 = 0.001; y7 = 0.01; 
            

                break; 

                case '吉林省':   //吉林
                    most = 20000; least = 5000;
                    r1 = 0; r2 = 100000; r3 = 500000; r4 = 1000000; r5 = 5000000;
                    r6 = 10000000; r7 = 20000000; r8 = 50000000;
                    x1 = 0, y1 = 0; x2 = 0.08; y2 = 0.1; x3 = 0.06; y3 = 0.08; x4 = 0.06; y4 = 0.07; x5 = 0.04; y5 = 0.06; x6 = 0.03; y6 = 0.05;
                    x7 = 0.02; y7 = 0.04;  x8 = 0.01; y8 = 0.03; 
                    // x8 = 0.005; y8 = 0.005;

                break; 





                default:
                if (t == 0) {
                    xmin = 3000;
                    xmax = 12000;
                }
                else if (t > 0 && t <= 100000) {
                    xmin = Math.max(t * 0.08, 3000);
                    xmax = Math.max(t * 0.12, 3000);
                }
                else if (t > 100000 && t <= 1000000) {
                    xmin = t * 0.05;
                    xmax = t * 0.07;
                }
                else if (t > 1000000 && t <= 10000000) {
                    xmin = t * 0.03;
                    xmax = t * 0.05;
                }
                else if (t > 10000000 && t <= 100000000) {
                    xmin = t * 0.01;
                    xmax = t * 0.03;
                }
                else if (t > 100000000) {
                    xmin = t * 0.005;
                    xmax = t * 0.01;
                }

            }




            

            if (t > r8 && r8 != 0) {
                xmin = (t - r8) * x8 + (r8 - r7) * x7 + (r7 - r6) * x6 + (r6 - r5) * x5 + (r5 - r4) * x4 + (r4 - r3) * x3 + (r3 - r2) * x2 + r2 * x1;
                xmax = (t - r8) * y8 + (r8 - r7) * y7 + (r7 - r6) * y6 + (r6 - r5) * y5 + (r5 - r4) * y4 + (r4 - r3) * y3 + (r3 - r2) * y2 + r2 * y1;
                window.console.log('stage8');
            }
            else if (t > r7 && r7 != 0) {
                xmin = (t - r7) * x7 + (r7 - r6) * x6 + (r6 - r5) * x5 + (r5 - r4) * x4 + (r4 - r3) * x3 + (r3 - r2) * x2 + r2 * x1;
                xmax = (t - r7) * y7 + (r7 - r6) * y6 + (r6 - r5) * y5 + (r5 - r4) * y4 + (r4 - r3) * y3 + (r3 - r2) * y2 + r2 * y1;
                window.console.log('stage7');
            }
            else if (t > r6 && r6 != 0) {
                xmin = (t - r6) * x6 + (r6 - r5) * x5 + (r5 - r4) * x4 + (r4 - r3) * x3 + (r3 - r2) * x2 + r2 * x1;
                xmax = (t - r6) * y6 + (r6 - r5) * y5 + (r5 - r4) * y4 + (r4 - r3) * y3 + (r3 - r2) * y2 + r2 * y1;
                window.console.log('stage6');
            }
            else if (t > r5 && r5 != 0) {
                xmin = (t - r5) * x5 + (r5 - r4) * x4 + (r4 - r3) * x3 + (r3 - r2) * x2 + r2 * x1;
                xmax = (t - r5) * y5 + (r5 - r4) * y4 + (r4 - r3) * y3 + (r3 - r2) * y2 + r2 * y1;
                window.console.log('stage5');
            }
            else if (t > r4) {
                xmin = (t - r4) * x4 + (r4 - r3) * x3 + (r3 - r2) * x2 + r2 * x1;
                xmax = (t - r4) * y4 + (r4 - r3) * y3 + (r3 - r2) * y2 + r2 * y1;
                window.console.log('stage4');
            }
            else if (t > r3) {
                xmin = (t - r3) * x3 + (r3 - r2) * x2 + r2 * x1;
                xmax = (t - r3) * y3 + (r3 - r2) * y2 + r2 * y1;
                window.console.log('stage3');
            }
            else if (t > r2) {
                xmin = (t - r2) * x2 + r2 * x1;
                xmax = (t - r2) * y2 + r2 * y1;
                window.console.log('stage2');
            }
            else if (t >= r1 ) {
                xmin = Math.max(t * x1, least);
                xmax = Math.max(t * y1, most);
        
            }
            


            if(xmin<=xmax){
                if( (x1==0||y1==0)&&t>r2 ){
                result = filters.toFix(xmin+least) + "-" + filters.toFix(xmax+most)+"元";
                console.log('xmin:',xmin)
                console.log('least:',least)

                console.log('1111111')
                }
                else{
                result = filters.toFix(xmin) + "-" + filters.toFix(xmax) + "元";
                console.log('222222222')

                }
            
                this.fee=result;
        
            }
            else{
                result = filters.toFix(xmin) + "元";
            
                this.fee=result;

            }


            
        

            }

            else if (this.index == '刑事案件') {
            switch (this.index2) {
                case '江苏省':    
                
                result ="侦察阶段：1000-8000 元 \n 审查起诉阶段：1000-10000 元\n 一审阶段：3000-20000 元  ";

                break; 

                case '广东省':    

                result = "侦察阶段：2000-6000 元 \n 审查起诉阶段：6000-16000 元\n 一审阶段：6000-33000 元  ";

                break; 

                case '浙江省':   

                result = "侦察阶段：2000-6000 元 \n 审查起诉阶段：6000-16000 元\n 一审阶段：6000-33000 元  ";

                break; 

                case '北京市':    

                result = "侦察阶段：2000-10000 元 \n 审查起诉阶段：2000-10000 元\n 一审阶段：4000-30000 元  ";

                break; 

                case '上海市':    

                result = "侦察阶段：1500-10000 元 \n 审查起诉阶段：2000-10000 元\n 一审阶段：3000-30000 元  ";

                break; 

                case '广西省':    

                result = "侦察阶段：2000-15000 元 \n 审查起诉阶段：2000-15000 元\n 一审阶段：2000-150000 元  ";

                break; 

                case '山东省':   

                result = "侦察阶段：1500-10000 元 \n 审查起诉阶段：2000-15000 元\n 一审阶段：2500-25000 元  ";

                break; 

                case '福建省':   
                result = "侦察阶段：1000-5000 元 \n 审查起诉阶段：1000-6000 元\n 一审阶段：1500-12000 元  ";

                break; 

                case '四川省':   

                result = "侦察阶段：2000-15000 元 \n 审查起诉阶段：2000-12000 元\n 审判阶段：3000-30000 元  ";

                break; 

                case '河北省':  

                result = "侦察阶段：2000-6000 元 \n 审查起诉阶段：3000-9000 元\n 审判阶段：4000-12000 元  ";

                break; 

                case '河南省':    

                result = "侦察阶段：3000-15000 元 \n 审查起诉阶段：5000-20000 元\n 审判阶段：5000-30000 元  ";

                break; 

                case '辽宁省':   

                result = "侦察阶段：8000 元 \n 审查起诉阶段：8000 元\n 审判阶段：8000 元  ";

                break;   

                case '黑龙江省':   

                result = "提供法律咨询：200 元/件 \n侦察阶段：1500 元 \n 审查起诉阶段：2000 元\n 审判阶段：3000 元 \n 以上可根据情况上浮40% ";

                break;   

                case '内蒙古省':   

                result = "提供法律咨询：100-2000 元/小时 \n侦察阶段：500-5000 元 \n 审查起诉阶段：500-5000 元\n 审判阶段：1000-20000 元  ";

                break;      

                case '重庆市':    

                result = "侦察阶段：2000-10000 元 \n 审查起诉阶段：2000-10000 元\n 审判阶段：3000-30000 元  ";

                break;   

                case '安徽省':    

                result = "侦察阶段：1200-8000 元 \n 审查起诉阶段：1200-8000 元\n 审判阶段：1200-15000 元  ";

                break;   

                case '湖北省':   

                result = "侦察阶段：1000-5000 元 \n 审查起诉阶段：1000-5000 元\n 审判阶段：1000-10000 元\n 经济类、共同犯罪案件上限可以增加5000  ";

                break; 

                case '湖南省':   

                result = "侦察阶段：1000-10000 元 \n 审查起诉阶段：1000-10000 元\n 审判阶段：2000-20000 元  ";

                break; 

                case '海南省':   

                result = "侦察阶段：2000-20000 元 \n 审查起诉阶段：3000-30000 元\n 审判阶段(基层法院）：2000-20000 元\n 审判阶段(中级法院）：5000-50000 元 ";

                break; 

                case '天津市':   

                result = "侦察阶段：5000-10000 元 \n 审查起诉阶段：5000-10000 元\n 审判阶段(基层法院）：5000-30000 元  ";

                break; 

                case '山西省':   //山西

                result = "侦察阶段：2000-20000 元 \n 审查起诉阶段：2000-20000 元\n 审判阶段(基层法院）：2500-35000 元  "

                break; 

                case '陕西省':   //陕西

                result = "侦察阶段：500-5000 元 \n 审查起诉阶段：1000-5000 元\n 审判阶段(基层法院）：1000-10000 元  \n 办理死刑复核案件：10000―30000元/件，但曾办理一审或二审的案件，按此标准酌减收费。"

                break; 

                case '云南省':   //云南

                result = "对不起，未找到刑事案件收费相关标准或指引。"

                break; 

                case '江西省':   

                    result = "侦察阶段：800-5000 元 \n 审查起诉阶段：800-5000 元\n 审判阶段(基层法院）：1600-15000 元  \n 未办一审而办二审的案件1000--10000元/件 \n 曾办一审又办二审的案件1000--5000元/件 \n 办理案情特别复杂，影响特别重大的刑事案件,可在上述标准五倍内与当事人协商 "
                break; 


                default:    

                result = "侦察阶段：1500-10000 元 \n 审查起诉阶段：2000-10000 元\n 审判阶段：3000-30000 元  ";




        }


        this.fee=result;
    

      

    }





        },


    }

	}
</script>

<style  >

 
/* body
{

    background-color: #f0f0f0;
  
}    */

/* 
    .function_wrap{
        height: 100%;

        display: flex;
        flex-direction: column;

        border:1px solid #c41cc4;
        margin-left: auto;
        margin-right: auto;
    }

    
.function_wrap.box{
  width:60%;
  height:100%;
  display: flex;
  flex-direction: column;
  border:1px solid #10be36;
  margin: auto;
  margin-top:10px;
  align-items: center;

  margin-left: auto;
  margin-right:auto;
}


.function_wrap.box_mobile{
  width:100%;
  height:670px;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top:80px;
  align-items: center;

  margin-left: auto;
  margin-right:auto;
}

.function_wrap.box.titlebar{
 
  height:30px;
  margin-top:20px;
  text-align: center;

  border:1px solid #10be36;
  
}
.function_wrap.box.title{
  font-size:25px;
  margin-top:10px;
  height: 30px;
  margin-bottom:4px;

}

.function_wrap.box.title_EN{
  font-size:16px;
  height: 24px;
  margin-top:0;
  margin-bottom: 10px;

  
}


.function_wrap_title{
  font-size:25px;
  margin-top:10px;
  height: 30px;
  margin-bottom:4px;
  text-align: center;
  width:100%;

}


.function_wrap_title_EN{
  font-size:16px;
  height: 24px;
  margin-top:0;
  margin-bottom: 10px;
  width:100%;
  text-align: center;

  
}



.optionitem{
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top:20px;
  width:70%;
}



.optionitem.item_name{
  width:30%;
  margin-top:0;

}
.optionitem.item_detail{
  width:70%;
  margin-top:0;
  
}

.optionitem.item_detail p{
  text-align: center;
  line-height: 30px;
}


.optionitem input{
  width:100%;
  text-align: center;

 
}


.confirm_box{
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top:60px;
  width:80%;

}

.confirm_box button{
  height: 100%;
  width:140px;
  border-radius: 8px;
  margin-left:auto;
  margin-right: auto;
 
   

}

.result{
  width:95%;
  border-top:1.5px solid #dedede;
  padding-left: 8px;
  margin-top:20px;
  line-height: 17px;

} */
 

 .guide{
  /* font-size:22rpx; */
  float: right;
  /* padding-right: 20rpx; */
  text-decoration: underline;
  margin-right: 20px;
  color: rgb(19, 109, 145);
  cursor: pointer;
}
 

</style>
